import React from "react";
import { Route } from "react-router-dom";
import { AUTH_LEVELS } from "../lib/globals";
import NotFound from "../components/NotFound";
import RequireAuth from "../components/RequireAuth";
import OpenGames, { loader as OpenGamesLoader } from "../pages/OpenGames";

export default (
    <Route element={<RequireAuth allowedUserLevels={AUTH_LEVELS.all} />}>
        <Route path="games" handle={{ crumb: () => "Open Games" }}>
            <Route
                path="majorybl"
                element={<OpenGames />}
                loader={params =>
                    OpenGamesLoader({
                        ...params,
                        site: 1,
                    })
                }
                handle={{
                    crumb: () => "MAJORYBL",
                    header: () => "Open MAJORYBL Games",
                }}
            />
            <Route
                path="wisconsin-baseball-tournaments"
                element={<OpenGames />}
                loader={params =>
                    OpenGamesLoader({
                        ...params,
                        site: 2,
                    })
                }
                handle={{
                    crumb: () => "Wisconsin Baseball Tournaments",
                    header: () => "Open Wisconsin Baseball Tournament Games",
                }}
            />
            <Route
                path="illinois-baseball-tournaments"
                element={<OpenGames />}
                loader={params =>
                    OpenGamesLoader({
                        ...params,
                        site: 3,
                    })
                }
                handle={{
                    crumb: () => "Illinois Baseball Tournaments",
                    header: () => "Open Illinois Baseball Tournament Games",
                }}
            />
        </Route>
        <Route path="*" element={<NotFound parent="schedule" />} />
    </Route>
);
